import { render, staticRenderFns } from "./reserve-time.vue?vue&type=template&id=2b8adbaa"
import script from "./reserve-time.vue?vue&type=script&lang=js"
export * from "./reserve-time.vue?vue&type=script&lang=js"
import style0 from "./reserve-time.vue?vue&type=style&index=0&id=2b8adbaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports